export default [
    { type: 'current', name: 'Assigned to me' },
    { type: 'unassigned', name: 'Unassigned' },
];
